export const validateTelephone = (
  t: (key: string) => string,
  _: any,
  value: string
): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (value === '') {
      reject(new Error(t('MSG_00_21')));
    } else if (!/^0\d{1,4}-\d{1,4}-\d{4}$/.test(value)) {
      reject(new Error(t('MSG_00_24')));
    } else {
      const arr = value.split('-');
      if (arr.length < 2) {
        reject(new Error(t('MSG_00_24')));
      }
      const len2 = arr[0].length + arr[1].length;
      if (len2 <= 5 || len2 > 7) {
        reject(new Error(t('MSG_00_24')));
      }
      if (value.length <= 9 || value.length > 13) {
        reject(new Error(t('MSG_00_24')));
      }
    }
    resolve();
  });
};
